import React from "react";
import styled from "styled-components/macro";
import { Popup } from "semantic-ui-react";
import { PopUpItem } from "./PopUpItem";

const UnitBox = ({
  quantity,
  showTopDivider,
  showBottomDivider,
  showRightDivider,
  item,
  colorUnit,
}) => {
  const {
    size,
    color,
    gradientColor,
    unitImage,
    image,
    frameColor = "#FFFFFF",
    showDoor = true,
  } = item;

  return (
    <Popup
      disabled={!image}
      position="right center"
      on="click"
      trigger={
        <Box style={{ cursor: "pointer" }}>
          {showTopDivider && <DividerHorizontal />}
          <Box style={{ flexDirection: "row" }}>
            <Wrapper frameColor={colorUnit || frameColor} size={size}>
              <InnerWrapper
                showDoor={showDoor}
                color={color}
                gradientColor={gradientColor}
              >
                <Shelf color={color} gradientColor={gradientColor} />
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "flex-end",
                  }}
                >
                  {unitImage && (
                    <img
                      src={unitImage}
                      style={{ objectFit: "contain", zIndex: 1 }}
                      alt={"Product"}
                    />
                  )}
                </div>
                {showDoor && (
                  <Rect
                    frameColor={colorUnit || frameColor}
                    gradientColor={gradientColor}
                  />
                )}
                {showDoor && <Pin frameColor={colorUnit || frameColor} />}
                {showDoor && <PinTop frameColor={colorUnit || frameColor} />}
              </InnerWrapper>
            </Wrapper>
            {showRightDivider && <DividerVertical size={size} />}
          </Box>
          {showBottomDivider && <DividerHorizontal />}
        </Box>
      }
      flowing
    >
      <PopUpItem item={item} quantity={quantity} />
    </Popup>
  );
};

const Box = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`;

const Wrapper = styled.div`
  z-index: 4;
  width: 166px;
  height: ${({ size }) => size}px;
  border: 7px solid ${({ frameColor }) => frameColor};
  align-items: center;
  justify-content: center;
  box-shadow: 1px 1px 5px #5a5a5a;
  position: relative;
  display: flex;
  border-radius: 2px;
`;

const InnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  // box-shadow: ${({ showDoor }) =>
    showDoor ? "0 3px 6px 0 rgba(0, 0, 0, 0.16)" : null};
  box-shadow: ${({ showDoor }) =>
    showDoor ? "inset 2px 2px 10px 5px rgba(0,0,0,0.16)" : null};
  background-image: linear-gradient(
    to bottom,
    ${({ color }) => color},
    ${({ gradientColor }) => gradientColor} 95%
  );
`;

const Shelf = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 6px;
  background-image: linear-gradient(
    to bottom,
    ${({ gradientColor }) => gradientColor},
    ${({ color }) => color} 65%
  );
  z-index: 0;
`;

const Pin = styled.div`
  position: absolute;
  bottom: 0;
  right: 6px;
  height: 5px;
  width: 13px;
  background-color: ${({ frameColor }) => frameColor};
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  z-index: 10;
`;

const PinTop = styled.div`
  position: absolute;
  top: 0;
  right: 6px;
  height: 5px;
  width: 13px;
  background-color: ${({ frameColor }) => frameColor};
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  z-index: 10;
`;
const Rect = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-top: 0 solid transparent;
  border-left: 35px solid ${({ frameColor }) => frameColor};
  border-bottom: 30px solid transparent;
  z-index: 10;
`;
const DividerHorizontal = styled.div`
  width: 144px;
  height: 8px;
  background-image: linear-gradient(to bottom, #e9e9e9, #c2c2c2);
  align-self: center;
`;

const DividerVertical = styled.div`
  width: 8px;
  height: ${({ size }) => size - 20}px;
  background-image: linear-gradient(to bottom, #e9e9e9, #c2c2c2);
  align-self: center;
`;
export { UnitBox };
